import axios from 'axios';
import {ElMessage} from "element-plus";
import {useAuthStore} from "@/stores/authStore";
// import router from "@/router";



// 创建axios实例
const instance = axios.create({
    baseURL: 'https://kyyclbs.com/prod-api', // 建议通过环境变量配置
    timeout: 8000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 按需添加 Token
instance.interceptors.request.use(
    config => {
        if (config.needAuth) {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

// 响应拦截器
instance.interceptors.response.use(
    response => {
        // 统一处理响应数据结构
        if (response.data && response.data.code === 200) {

            return response.data.data || response.data ;

        }
        if(response.data && response.data.code === 401) {

            ElMessage.error('登录已过期，请重新登录')
            // 1. 清除本地 Token
            localStorage.removeItem('token')
            // 2. 清除路由守卫中的状态 (如果用了 Pinia/Vuex)
            const authStore = useAuthStore();
            authStore.clearAuthData()
            authStore.showLogin()
            // 3. 跳转到登录页
            // router.push('/login')
        }
        if(response.data && response.data.code === 500) {

            ElMessage.error(response.data.msg);

        }
        return Promise.reject(response.data.message || 'API响应错误');
    },
    error => {
        return Promise.reject(error.response?.data?.message || '网络请求失败');
    }
);

// 统一请求方法
const api = {
    // get: (url,data) => instance.get(url,data),
    // post: (url, data) => instance.post(url, data),
    // put: (url, data) => instance.put(url, data),
    // delete: (url,data) => instance.delete(url,data)

    // get: (url, data, config = {}) => instance.get(url, data, config),
    // post: (url, data, config = {}) => instance.post(url, data, config),
    // put: (url, data, config = {}) => instance.put(url, data, config),
    // delete: (url, config = {}) => instance.delete(url, config)

    // GET 请求（推荐写法）
    get(url, params = {}, headers = {}) {
        return instance.get(url, {
            params,           // 查询参数
            headers,          // 自定义 headers
            needAuth: true    // 默认需要认证
        });
    },

    // POST 请求
    post(url, data = {}, headers = {}) {
        return instance.post(url, data, {
            headers,
            needAuth: true
        });
    },

    // PUT 请求
    put(url, data = {}, headers = {}) {
        return instance.put(url, data, {
            headers,
            needAuth: true
        });
    },

    // DELETE 请求
    delete(url, params = {}, headers = {}) {
        return instance.delete(url, {
            params,
            headers,
            needAuth: true
        });
    }

};

// 导出API实例
export default api;
